import React from 'react';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { hashHistory } from 'react-router';
import { WidgetGrid, JarvisWidget } from '../../../components';
import AdvocateTable from './AdvocateTable';
import AdvocatesList from './AdvocatesList';
//import VisitNotesListMobile from './VisitNotesListMobile';
import AdvocateView from './AdvocateView';
import { requestOutreaches, updateOutreach } from '../../../store/outreach/OutreachActions';
import {
  requestAdvocate, requestEmployersTypeahead, requestLocationsTypeahead, requestFiltersTypeahead,
  importOutreachData, saveAdvocateQuery, requestAdvocateQuery, updateAdvocateQuery, deleteAdvocateQuery
} from '../../../store/advocate-dashboard/AdvocateActions';
import AdvocateFiltersForm from '../components/AdvocateFiltersForm';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import InfoBar from '../../../components/common/InfoBar';
import { BigBreadcrumbs } from '../../../components';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { humanFileSize } from '../../../components/utils/format';
import classNames from 'classnames';

class AdvocateLayout extends React.Component {
  constructor(props) {
    super(props);

    const query = this.props.location.query;

    this.state = {
      showNotes: false,
      editFlagsMode: false,
      sort: '',
      filter: query.filter ? query.filter : '',
      filters: {},
      search: '',
      page: 0,
      perPage: 25,
      pages: -1,
      selectedNote: null,
      viewLayout: 'detail',
      queryParams: {},
      location: [],
      employer: [],
      msFilter: [],
      showModal: false,
      importFiles: [],
      ageMin: 0,
      ageMax: 200,
      month: 0,
      newFilters: {},
      key: 0,
      queryId: '',
      showCreateView: false
    };
    this.prevNote = this.prevNote.bind(this);
    this.nextNote = this.nextNote.bind(this);
    this.toggleNotes = this.toggleNotes.bind(this);
    this.changeEmployerFilters = this.changeEmployerFilters.bind(this);
    this.changeLocationFilters = this.changeLocationFilters.bind(this);
    this.changeFilters = this.changeFilters.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.import = this.import.bind(this);
    this.setAllFilters = this.setAllFilters.bind(this);
    this.patientProfile = this.patientProfile.bind(this);
  }

  componentWillMount() {
    if (this.props.currentUser.queryParams) {
      this.setState({
        queryParams: this.props.currentUser.queryParams,
      });
    }
    this.props.getAdvocateQuery({
      tenantId: this.props.currentUser.queryParams.tenantId,
    });

    //var filters = JSON.parse(localStorage.getItem('filters'));
    //var companies = JSON.parse(localStorage.getItem('employers'));
    //var locations = JSON.parse(localStorage.getItem('locations'));
    //var ageMin = (localStorage.getItem('ageMin') === null) ? 0 : localStorage.getItem('ageMin');
    //var ageMax = (localStorage.getItem('ageMax') === null) ? 0 : localStorage.getItem('ageMax');
    //var month = (localStorage.getItem('month') === null) ? 0 : localStorage.getItem('month');
    //this.setState({ location: locations });
    //this.setState({ employer: companies });
    //this.setState({ msFilter: filters });
    //this.setState({ ageMin: ageMin });
    //this.setState({ ageMax: ageMax });
    //this.setState({ month: month });

    //if ((filters !== null) && (companies !== null) && (locations !== null)) {
    //  filters = filters.map(el => el.code);
    //  companies = companies.map(el => el.code);
    //  locations = locations.map(el => el.code);
    //  this.setState({ filters: { ...this.filters, filters, companies, locations, ageMin, ageMax, month  } }, () =>
    //    this.fetch(),
    //  );
    //}
    //else if ((filters !== null) && (companies !== null) && (locations === null)) {
    //  filters = filters.map(el => el.code);
    //  companies = companies.map(el => el.code);
    //  this.setState({ filters: { ...this.filters, filters, companies, ageMin, ageMax, month  } }, () =>
    //    this.fetch(),
    //  );
    //}
    //else if ((filters === null) && (companies !== null) && (locations !== null)) {
    //  companies = companies.map(el => el.code);
    //  locations = locations.map(el => el.code);
    //  this.setState({ filters: { ...this.filters, companies, locations, ageMin, ageMax, month  } }, () =>
    //    this.fetch(),
    //  );
    //}
    //else if ((filters !== null) && (companies === null) && (locations !== null)) {
    //  filters = filters.map(el => el.code);
    //  locations = locations.map(el => el.code);
    //  this.setState({ filters: { ...this.filters, filters, locations, ageMin, ageMax, month  } }, () =>
    //    this.fetch(),
    //  );
    //}
    //else if ((filters === null) && (companies === null) && (locations !== null)) {
    //  locations = locations.map(el => el.code);
    //  this.setState({ filters: { ...this.filters, locations, ageMin, ageMax, month  } }, () =>
    //    this.fetch(),
    //  );
    //}
    //else if ((filters !== null) && (companies === null) && (locations === null)) {
    //  filters = filters.map(el => el.code);
    //  this.setState({ filters: { ...this.filters, filters, ageMin, ageMax, month } }, () =>
    //    this.fetch(),
    //  );
    //}
    //else if ((filters === null) && (companies !== null) && (locations === null)) {
    //  companies = companies.map(el => el.code);
    //  this.setState({ filters: { ...this.filters, companies, ageMin, ageMax, month } }, () =>
    //    this.fetch(),
    //  );
    //}

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentUser.queryParams !== this.state.queryParams) {
      this.setState(
        {
          queryParams: nextProps.currentUser.queryParams,
        },
        () => this.fetch(),
      );
    }
  }

  changeView = (viewLayout) => this.setState({ viewLayout });

  patientProfile = (masterPatientId) => {
    hashHistory.push(`/patients/profile/${masterPatientId}`);
  };

  toggleNotes = (editFlagsMode = false, forceShow = false) => {
    this.setState({
      showNotes: forceShow ? true : !this.state.showNotes,
      editFlagsMode,
    });
  };

  selectNote = (note, forceScroll) => {
    if (!note) {
      return false;
    }
    if (forceScroll) {
      const { AdvocatesList } = this.refs;
      if (AdvocatesList.refs[note.patientId]) {
        AdvocatesList.refs[note.patientId]
          .getWrappedInstance()
          .refs[note.patientId].scrollIntoView({
            block: 'end',
            behavior: 'smooth',
          });
      }
    }
    const {
      data: { list },
    } = this.props;
    const pageIndex = list.findIndex((item) => item === note);
    return this.setState(
      {
        selectedNote: note,
        selectedNodeIndex: pageIndex,
      },
      () => {
        if (note) {
          this.props.getAdvocate(note.patientId, this.state.queryParams);
          this.props.getOutreaches({
            masterId: note.patientId,
            tenantId: this.props.currentUser.queryParams.tenantId,
            order: 'desc date'
          });
        }
      },
    );
  };

  prevNote = () => {
    const {
      data: { list },
      isLoading,
    } = this.props;
    const { selectedNodeIndex, page, perPage } = this.state;
    if (isLoading) {
      return true;
    }
    if (list[selectedNodeIndex - 1]) {
      this.selectNote(list[selectedNodeIndex - 1], true);
    } else if (page >= 1) {
      this.preFetch(page - 1, perPage).then((response) => {
        const {
          payload: {
            data: { list: newList },
          },
        } = response;
        this.selectNote(newList[newList.length - 1], true);
      });
    }
  };

  nextNote = () => {
    const {
      data: { list, total },
      isLoading,
    } = this.props;
    if (isLoading) {
      return true;
    }
    const { selectedNodeIndex, page, perPage } = this.state;
    if (list[selectedNodeIndex + 1]) {
      this.selectNote(list[selectedNodeIndex + 1], true);
    } else if (page < total) {
      this.preFetch(page + 1, perPage).then((response) => {
        const {
          payload: {
            data: { list: newList },
          },
        } = response;
        this.selectNote(newList[0], true);
      });
    }
  };

  getNoteLink = (id) =>
    `${window.location.protocol}//${window.location.host}/#/patients/profile/${id}`;

  canPrevNote = () =>
    this.state.selectedNodeIndex > 0 ||
    (this.state.selectedNodeIndex === 0 && this.state.page >= 1);

  canNextNote = () =>
    this.props.data.list &&
    (this.state.selectedNodeIndex < this.props.data.list.length - 1 ||
      this.state.page + 1 < this.state.pages);

  addAction = (values) => {
    const { selectedNote } = this.state;
    if (selectedNote) {
      return this.props
        .updateOutreach(values, {
          tenantId: this.props.currentUser.queryParams.tenantId
        })
        .then(() => {
          toast.success('Outreach Saved.');
          this.props.getOutreaches({
            masterId: selectedNote.patientId,
            tenantId: this.props.currentUser.queryParams.tenantId,
            order: 'desc date'
          });
          this.setState({
            showNotes: false,
          });
          this.props.getAdvocate(selectedNote.patientId, this.state.queryParams);
          //$('#lastOutreachDate_' + selectedNote.patientId).text(info.lastOutreachDate);
        });
    }
  };

  preFetch = (page, perPage) => {
    return new Promise((resolve) => {
      this.setState(
        {
          page: page !== this.state.page ? page : this.state.page,
          perPage,
        },
        () => resolve(this.fetch(page, perPage)),
      );
    });
  };

  downloadFile() {
    this.props
      .fetchDownload(
        this.state.page,
        this.state.perPage,
        "patientId",
        this.state.search,
        this.state.filter,
        this.state.filters
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "PatientAdvocate";
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  import() {
    this.setState({ showModal: true });
  }

  onStartUpload() {
    this.props
      .importData(
        {
          tenantId: this.props.currentUser.queryParams.tenantId
        },
        this.state.importFiles,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Data imported.');
          this.setState({ showModal: false, importFiles: [] }, () => this.fetch());
        }
      });
  }

  showModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
    this.onCancel();
  }

  showCreateViewModal() {
    this.setState({ showCreateView: true });
  }

  closeCreateViewModal() {
    this.setState({ showCreateView: false });
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleViewChange(value, queries) {
    var query = queries.filter(el => el.id === value);
    var filters = (Number(value) === 0) ? [] : JSON.parse(query[0].query).filters;
    var companies = (Number(value) === 0) ? [] : JSON.parse(query[0].query).companies;
    var locations = (Number(value) === 0) ? [] : JSON.parse(query[0].query).locations;
    var ageMin = (Number(value) === 0) ? 0 : JSON.parse(query[0].query).ageMin;
    var ageMax = (Number(value) === 200) ? 200 : JSON.parse(query[0].query).ageMax;
    var month = (Number(value) === 0) ? 0 : JSON.parse(query[0].query).month;

    this.setState({ location: locations });
    this.setState({ employer: companies });
    this.setState({ msFilter: filters });
    this.setState({ ageMin: ageMin });
    this.setState({ ageMax: ageMax });
    this.setState({ month: month });

    this.setState({ queryId: value });
    this.setState({ key: this.state.key + 1 });

    filters = filters.map(el => el.code);
    companies = companies.map(el => el.code);
    locations = locations.map(el => el.code);
    this.setState({ filters: { ...this.filters, filters, companies, locations, ageMin, ageMax, month } }, () =>
      this.fetch(),
    );
  }

  createNewView() {
      this.props.saveAdvocateQuery(
          {
          tenantId: this.props.currentUser.queryParams.tenantId,
          title: this.state.value,
          query: JSON.stringify(this.state.newFilters)
          },
        )
        .then((result) => {
          if (result.error) {
            const message = _.get(result, 'payload.response.error.message', null);
            if (message) {
              toast.error(message);
            } else {
              toast.error('Something went wrong. Try again later.');
            }
          }
          else {
            toast.success('View saved successfully.');
            this.setState({ showCreateView: false });
            this.setState({ value: '' });
            this.props.getAdvocateQuery({
              tenantId: this.props.currentUser.queryParams.tenantId,
            });
            //$("#view").val("0");
            //this.handleViewChange(0, this.props.queries);
          }
        });
  }

  updateView() {
    this.props.updateAdvocateQuery(this.state.queryId,
      {
        tenantId: this.props.currentUser.queryParams.tenantId,
        query: JSON.stringify(this.state.newFilters)
      })
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        }
        else {
          toast.success('View updated.');
          this.props.getAdvocateQuery({
            tenantId: this.props.currentUser.queryParams.tenantId,
          });
          //$("#view").val("0");
          //this.handleViewChange(0, this.props.queries);
        }
      });
  }

  deleteView() {
    this.props.deleteAdvocateQuery(this.state.queryId,
      {
      tenantId: this.props.currentUser.queryParams.tenantId,
      })
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        }
        else {
          toast.success('View deleted.');
          this.props.getAdvocateQuery({
            tenantId: this.props.currentUser.queryParams.tenantId,
          });
          $("#view").val("0");
          this.handleViewChange(0, this.props.queries);
        }
      });
  }

  onDrop(files) {
    if (this.state.importFiles.length === 0) {
      const filesToAdd = _.difference(files, this.state.importFiles);
      this.setState({
        importFiles: this.state.importFiles.concat(filesToAdd),
      });
    }
  }

  onCancel() {
    this.setState({
      importFiles: [],
    });
  }

  removeFileFromUploadList(fileName) {
    this.setState({
      importFiles: this.state.importFiles.filter(
        (file) => file.name !== fileName,
      ),
    });
  }

  fetch = (page = this.state.page, perPage = this.state.perPage) => {
    return this.props
      .fetchNotes(
        this.state.page,
        this.state.perPage,
        this.state.sort,
        this.state.search,
        this.state.filter,
        this.state.filters,
      )
      .then((response) => {
        if (response) {
          this.setState({
            pages:
              response.payload.data && response.payload.data.total
                ? Math.ceil(response.payload.data.total / this.state.perPage)
                : '0',
          });
        }
        return response;
      });
  };

  setSort = (sort) => {
    if (this.state.sort.indexOf(sort) > -1) {
      if (this.state.sort.indexOf('desc ') === 0) {
        sort = `asc ${sort}`;
      } else {
        sort = `desc ${sort}`;
      }
    } else {
      sort = `desc ${sort}`;
    }
    return this.setState(
      {
        sort: sort,
      },
      () => this.fetch(),
    );
  };

  setFilter = (filter) => {
    return this.setState(
      {
        filter,
      },
      () => {
        const query = this.props.location.query;
        if (filter) {
          query.filter = filter;
        } else {
          delete query.filter;
        }
        hashHistory.push({
          pathname: this.props.location.pathname,
          query: query,
        });
        this.fetch();
      },
    );
  };

  onAgeMinChange = (param) => {
    this.setState({ ageMin: param });
    setTimeout(() => this.setAllFilters(), 500);
    localStorage.setItem('ageMin', param);
  }
 
  onAgeMaxChange = (param) => {
    this.setState({ ageMax: param });
    setTimeout(() => this.setAllFilters(), 500);
    localStorage.setItem('ageMax', param);
  };

  onMonthChange = (param) => {
    if (Number(param) === 13) {
      $("#month").val("0");
      this.setState({ month: 0 });
    }
    else {
      this.setState({ month: param });
    }
    setTimeout(() => this.setAllFilters(), 500);
    setTimeout(() => localStorage.setItem('month', this.state.month), 500);
  };

  setAllFilters() {
    var locations = this.state.location ? (this.state.location.provider ? this.state.location.provider : this.state.location) : [];
    var companies = this.state.employer ? (this.state.employer.provider ? this.state.employer.provider : this.state.employer) : [];
    var filters = this.state.msFilter ? (this.state.msFilter.provider ? this.state.msFilter.provider : this.state.msFilter) : [];
    var ageMin = this.state.ageMin;
    var ageMax = this.state.ageMax;
    var month = this.state.month;
    this.setState({ newFilters: { ...this.newFilters, filters, companies, locations, ageMin, ageMax, month } });

    if (Number(ageMin) > Number(ageMax)) {
      toast.error('Age Min should be less than Age Max.');
    }
    else {
      if ((filters !== null) && (companies !== null) && (locations !== null)) {
        filters = filters.map(el => el.code);
        companies = companies.map(el => el.code);
        locations = locations.map(el => el.code);
        this.setState({ filters: { ...this.filters, filters, companies, locations, ageMin, ageMax, month } }, () =>
          this.fetch(),
        );
      }
      else if ((filters !== null) && (companies !== null) && (locations === null)) {
        filters = filters.map(el => el.code);
        companies = companies.map(el => el.code);
        this.setState({ filters: { ...this.filters, filters, companies, ageMin, ageMax, month } }, () =>
          this.fetch(),
        );
      }
      else if ((filters === null) && (companies !== null) && (locations !== null)) {
        companies = companies.map(el => el.code);
        locations = locations.map(el => el.code);
        this.setState({ filters: { ...this.filters, companies, locations, ageMin, ageMax, month } }, () =>
          this.fetch(),
        );
      }
      else if ((filters !== null) && (companies === null) && (locations !== null)) {
        filters = filters.map(el => el.code);
        locations = locations.map(el => el.code);
        this.setState({ filters: { ...this.filters, filters, locations, ageMin, ageMax, month } }, () =>
          this.fetch(),
        );
      }
      else if ((filters === null) && (companies === null) && (locations !== null)) {
        locations = locations.map(el => el.code);
        this.setState({ filters: { ...this.filters, locations, ageMin, ageMax, month } }, () =>
          this.fetch(),
        );
      }
      else if ((filters !== null) && (companies === null) && (locations === null)) {
        filters = filters.map(el => el.code);
        this.setState({ filters: { ...this.filters, filters, ageMin, ageMax, month } }, () =>
          this.fetch(),
        );
      }
      else if ((filters === null) && (companies !== null) && (locations === null)) {
        companies = companies.map(el => el.code);
        this.setState({ filters: { ...this.filters, companies, ageMin, ageMax, month } }, () =>
          this.fetch(),
        );
      }
    }
  }

  setSearch = (search) => {
    return this.setState(
      {
        search,
      },
      () => this.fetch(),
    );
  };

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters: null,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            if (item.masterId) {
              options.push({
                id: item.id,
                masterId: item.masterId,
                lastName: item.lastName,
                firstName: item.firstName,
              });
            }
          });
        }
        return options;
      });
  };

  searchLocations = (search) => {
    return this.props
      .locationsTypeahead({
        tenantId: this.props.currentUser.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.currentUser.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  searchEmployers = (search) => {
    return this.props
      .employersTypeahead({
        tenantId: this.props.currentUser.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  changeLocationFilters(params) {
    this.setState({ location: { ...this.location, ...params } });
    this.setAllFilters();
    localStorage.setItem('locations', JSON.stringify(params.provider));
  }

  changeEmployerFilters(params) {
    this.setState({ employer: { ...this.employer, ...params } });
    this.setAllFilters();
    localStorage.setItem('employers', JSON.stringify(params.provider));
  }

  changeFilters(params) {
    this.setState({ msFilter: { ...this.msFilter, ...params } });
    this.setAllFilters();
    localStorage.setItem('filters', JSON.stringify(params.provider));
  }

  searchFilters = (search) => {
    return this.props
      .filtersTypeahead({
        tenantId: this.props.currentUser.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  render() {
    const {
      data,
      isLoading,
      outreach,
      view,
      advocate,
      queries,
      isExecutive
    } = this.props;
    const { sort, filter, viewLayout } = this.state;

    const filesToUpload = this.state.importFiles.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));

    const PERCENTAGES = [...new Array(101)]
      .map((each, index) => ({ label: index, value: index }));

    const PERCENTAGES1 = [...new Array(100)]
      .map((each, index) => ({ label: index+1, value: index+1 }));

    return (
      <div id="content" className="clinic-activity">
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={[
                'Practice Management',
                {
                  title: 'Outreach Dashboard',
                  route: '/advocate-dashboard',
                },
              ]}
              icon="fa fa-fw fa-hospital-o"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          {/*<div className="tablet-list-navigation">*/}
          {/*  <div className="tablet-nav-list">*/}
          {/*    <VisitNotesListMobile*/}
          {/*      data={data}*/}
          {/*      limits={limits}*/}
          {/*      title={title}*/}
          {/*      isLoading={isLoading}*/}
          {/*      selected={this.state.selectedNote}*/}
          {/*      fetchData={this.preFetch}*/}
          {/*      selectNote={this.selectNote}*/}
          {/*      onNextPage={this.nextPage}*/}
          {/*      onPrevPage={this.prevPage}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*  <div className="tablet-nav-sort">*/}
          {/*    <Dropdown className="btn-group" id="table-nav-sort">*/}
          {/*      <Dropdown.Toggle className="btn dropdown-toggle">*/}
          {/*        Sort{' '}*/}
          {/*        {sort.indexOf('dateOfService') > -1 && (*/}
          {/*          <strong>Date Of Service</strong>*/}
          {/*        )}*/}
          {/*        {sort.indexOf('visitNoteID') > -1 && (*/}
          {/*          <strong>Visit Note ID</strong>*/}
          {/*        )}*/}
          {/*        {sort.indexOf('patientID') > -1 && (*/}
          {/*          <strong>Patient ID</strong>*/}
          {/*        )}{' '}*/}
          {/*        {sort.indexOf('desc') === 0 && <strong>DESC</strong>}*/}
          {/*        {sort.indexOf('asc') === 0 && <strong>ASC</strong>}*/}
          {/*      </Dropdown.Toggle>*/}
          {/*      <Dropdown.Menu className="dropdown-menu pull-right">*/}
          {/*        <MenuItem*/}
          {/*          className={*/}
          {/*            sort.indexOf('dateOfService') > -1 ? 'active' : ''*/}
          {/*          }*/}
          {/*          onClick={() => this.setSort('dateOfService')}*/}
          {/*        >*/}
          {/*          Date Of Service*/}
          {/*          {sort.indexOf('dateOfService') > -1 &&*/}
          {/*            sort.indexOf('desc') === 0 && (*/}
          {/*              <i className="fa fa-sort-numeric-desc pull-right" />*/}
          {/*            )}*/}
          {/*          {sort.indexOf('dateOfService') > -1 &&*/}
          {/*            sort.indexOf('asc') === 0 && (*/}
          {/*              <i className="fa fa-sort-numeric-asc pull-right" />*/}
          {/*            )}*/}
          {/*        </MenuItem>*/}
          {/*        <MenuItem*/}
          {/*          className={sort.indexOf('visitNoteID') > -1 ? 'active' : ''}*/}
          {/*          onClick={() => this.setSort('visitNoteID')}*/}
          {/*        >*/}
          {/*          Visit Note ID*/}
          {/*          {sort.indexOf('visitNoteID') > -1 &&*/}
          {/*            sort.indexOf('desc') === 0 && (*/}
          {/*              <i className="fa fa-sort-numeric-desc pull-right" />*/}
          {/*            )}*/}
          {/*          {sort.indexOf('visitNoteID') > -1 &&*/}
          {/*            sort.indexOf('asc') === 0 && (*/}
          {/*              <i className="fa fa-sort-numeric-asc pull-right" />*/}
          {/*            )}*/}
          {/*        </MenuItem>*/}
          {/*        <MenuItem*/}
          {/*          className={sort.indexOf('patientID') > -1 ? 'active' : ''}*/}
          {/*          onClick={() => this.setSort('patientID')}*/}
          {/*        >*/}
          {/*          Patient ID*/}
          {/*          {sort.indexOf('patientID') > -1 &&*/}
          {/*            sort.indexOf('desc') === 0 && (*/}
          {/*              <i className="fa fa-sort-numeric-desc pull-right" />*/}
          {/*            )}*/}
          {/*          {sort.indexOf('patientID') > -1 &&*/}
          {/*            sort.indexOf('asc') === 0 && (*/}
          {/*              <i className="fa fa-sort-numeric-asc pull-right" />*/}
          {/*            )}*/}
          {/*        </MenuItem>*/}
          {/*      </Dropdown.Menu>*/}
          {/*    </Dropdown>*/}
          {/*  </div>*/}
          {/*  <div className="tablet-nav-filter">*/}
          {/*    <Dropdown className="btn-group" id="tablet-nav-filter">*/}
          {/*      <Dropdown.Toggle className="btn dropdown-toggle">*/}
          {/*        Filter{' '}*/}
          {/*      </Dropdown.Toggle>*/}
          {/*      <Dropdown.Menu>*/}
          {/*        <MenuItem*/}
          {/*          className={filter.indexOf('locked') === 0 ? 'active' : ''}*/}
          {/*          onClick={() => this.setFilter('locked')}*/}
          {/*        >*/}
          {/*          Locked*/}
          {/*        </MenuItem>*/}
          {/*        <MenuItem*/}
          {/*          className={filter.indexOf('unlocked') === 0 ? 'active' : ''}*/}
          {/*          onClick={() => this.setFilter('unlocked')}*/}
          {/*        >*/}
          {/*          Unlocked*/}
          {/*        </MenuItem>*/}
          {/*        {isProtocolFlags && (*/}
          {/*          <MenuItem*/}
          {/*            className={filter.indexOf('msk') === 0 ? 'active' : ''}*/}
          {/*            onClick={() => this.setFilter('msk')}*/}
          {/*          >*/}
          {/*            MSK*/}
          {/*          </MenuItem>*/}
          {/*        )}*/}
          {/*        {isProtocolFlags && (*/}
          {/*          <MenuItem*/}
          {/*            className={*/}
          {/*              filter.indexOf('diabetes') === 0 ? 'active' : ''*/}
          {/*            }*/}
          {/*            onClick={() => this.setFilter('diabetes')}*/}
          {/*          >*/}
          {/*            Diabetes*/}
          {/*          </MenuItem>*/}
          {/*        )}*/}
          {/*        */}{/* {isProtocolFlags && (*/}{/*
          */}{/*          <MenuItem*/}{/*
          */}{/*            className={*/}{/*
          */}{/*              filter.indexOf('reviewed') === 0 ? 'active' : ''*/}{/*
          */}{/*            }*/}{/*
          */}{/*            onClick={() => this.setFilter('reviewed')}*/}{/*
          */}{/*          >*/}{/*
          */}{/*            Reviewed*/}{/*
          */}{/*          </MenuItem>*/}{/*
          */}{/*        )} */}
          {/*        {isProtocolFlags && (*/}
          {/*          <MenuItem*/}
          {/*            className={filter.indexOf('bmi') === 0 ? 'active' : ''}*/}
          {/*            onClick={() => this.setFilter('bmi')}*/}
          {/*          >*/}
          {/*            BMI*/}
          {/*          </MenuItem>*/}
          {/*        )}*/}
          {/*        {isAlerts && (*/}
          {/*          <MenuItem*/}
          {/*            className={filter.indexOf('bmi') === 0 ? 'active' : ''}*/}
          {/*            onClick={() => this.setFilter('bmi')}*/}
          {/*          >*/}
          {/*            BMI*/}
          {/*          </MenuItem>*/}
          {/*        )}*/}
          {/*        <MenuItem divider />*/}
          {/*        <MenuItem onClick={() => this.setFilter('')}>*/}
          {/*          <i className="fa fa-power-off" /> Clear*/}
          {/*        </MenuItem>*/}
          {/*      </Dropdown.Menu>*/}
          {/*    </Dropdown>*/}
          {/*  </div>*/}
          {/*  <div className="tablet-nav-search">*/}
          {/*    <div className="input-group">*/}
          {/*      <input*/}
          {/*        className="form-control"*/}
          {/*        type="text"*/}
          {/*        placeholder="Search..."*/}
          {/*      />*/}
          {/*      <div className="input-group-btn">*/}
          {/*        <button className="btn btn-default" type="button">*/}
          {/*          <i className="fa fa-search" />*/}
          {/*        </button>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className="telemetry-filters">
            <select id="view" onChange={e => this.handleViewChange(e.target.value, queries)}>
              <option value="0">Default View</option>
              {queries &&
                queries.map((el) => (
                  <option key={el.id} value={el.id}>
                    {el.title}
                  </option>
                ))}
            </select>
            &nbsp;&nbsp;
            <button className="btn btn-primary" onClick={this.showCreateViewModal.bind(this)}>Create New View</button>
            &nbsp;&nbsp;
            <button className="btn btn-success" onClick={this.updateView.bind(this)}>Update View</button>
            &nbsp;&nbsp;
            <button className="btn btn-danger" onClick={this.deleteView.bind(this)}>Delete View</button>
          </div>

          <div className="telemetry-filters">
            {/*<LocationsFilterForm title="Employers" searchLocations={this.searchEmployers} isMulti={true} onSubmit={this.changeEmployerFilters} />*/}
            {/*&nbsp;&nbsp;*/}
            {/*<LocationsFilterForm title="Locations" searchLocations={this.searchLocations} isMulti={true} onSubmit={this.changeLocationFilters} />*/}
            {/*&nbsp;&nbsp;*/}
            <AdvocateFiltersForm searchEmployers={this.searchEmployers} searchLocations={this.searchLocations} searchFilters={this.searchFilters} key={this.state.key}
              selectedEmployerOption={this.state.employer} selectedLocationOption={this.state.location} selectedFilterOption={this.state.msFilter}
              isMulti={true} onSubmit={this.changeFilters} onEmployerSubmit={this.changeEmployerFilters} onLocationSubmit={this.changeLocationFilters} />
            &nbsp;&nbsp;
            <button className="btn btn-primary" onClick={this.downloadFile}>Download</button>
            &nbsp;&nbsp;
            <button className="btn btn-primary" onClick={this.import}>Bulk Upload Outreach</button>
            <div className="view-switch hidden-xs">
              <div className="btn-group">
                <button
                  type="button"
                  title="List"
                  onClick={() => this.changeView('list')}
                  className={`btn btn-default ${
                    viewLayout === 'list' ? 'active' : ''
                    }`}
                >
                  <i className="fa fa-list"></i>{' '}
                </button>
                <button
                  type="button"
                  title="Detail"
                  onClick={() => this.changeView('detail')}
                  className={`btn btn-default ${
                    viewLayout === 'detail' ? 'active' : ''
                    }`}
                >
                  <i className="fa fa-file-text-o"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="telemetry-filters">
            <span>Age Min. </span>&nbsp;&nbsp;
            <select name="ageMin" value={this.state.ageMin} onChange={e => this.onAgeMinChange(e.target.value)}>
              {PERCENTAGES.map((option, i) => (
                <option key={i} value={option.value}>
                  {`${option.label}`}
                </option>
              ))}
            </select>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span>Age Max. </span>&nbsp;&nbsp;
            <select name="ageMax" value={this.state.ageMax} onChange={e => this.onAgeMaxChange(e.target.value)}>
              <option value="200" selected >Unlimited</option>
              {PERCENTAGES1.map((option, i) => (
                <option key={i} value={option.value}>
                  {`${option.label}`}
                </option>
              ))}
            </select>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span>Birth Month</span>&nbsp;&nbsp;
            <select id="month" name="month" value={this.state.month} onChange={e => this.onMonthChange(e.target.value)} >
              <option value="0" disabled>Month</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
              <option value="13" className="txt-color-customblue">Clear</option>
            </select>
          </div>
          <Modal show={this.state.showModal}>
            <Modal.Header>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
                onClick={this.closeModal.bind(this)}
              >
                &times;
              </button>
              <h4 className="modal-title" id="addFilesModalLabel">
                Add Files
              </h4>
            </Modal.Header>
            <Modal.Body>
              <div className="row client-files-upload">
                <div
                  className={
                    this.state.importFiles.length > 0
                      ? 'col-sm-12'
                      : 'col-sm-12'
                  }
                >
                  <Dropzone
                    accept={".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"}
                    onDrop={this.onDrop.bind(this)}
                    onFileDialogCancel={this.onCancel.bind(this)}
                  >
                    {({
                      getRootProps,
                      getInputProps,
                      isDragActive,
                    }) => {
                      return (
                        <div
                          {...getRootProps()}
                          className={classNames(
                            'dropzone dropzone-client-files',
                            { 'dropzone--isActive': isDragActive },
                          )}
                        >
                          <input {...getInputProps()} />
                          {isDragActive ? (
                            <p>Drop files here...</p>
                          ) : (
                            <span className="text-center">
                              <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                <span className="font-lg">
                                  Drop files{' '}
                                  <span className="font-xs">
                                    to upload
                                  </span>
                                </span>
                                <span>
                                  &nbsp;&nbsp;
                                  <h4 className="display-inline">
                                    {' '}
                                    (Or Click)
                                  </h4>
                                </span>
                              </span>
                            </span>
                          )}
                        </div>
                      );
                    }}
                  </Dropzone>
                </div>
                {this.state.importFiles.length > 0 && (
                  <div className="col-sm-12">
                    <h4>Files to be uploaded</h4>
                    <ul className="list-group files-upload-list">
                      {filesToUpload}
                    </ul>
                    {` `}
                    {this.state.importFiles.length === 1 && (
                      <h6 className="txt-color-customblue">Only one file per request accepted.</h6>
                    )}
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                onClick={this.closeModal.bind(this)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={this.state.importFiles.length === 0}
                onClick={this.onStartUpload.bind(this)}
              >
                Import Data
              </button>
            </Modal.Footer>
          </Modal>

          <Modal show={this.state.showCreateView}>
            <Modal.Header>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
                onClick={this.closeCreateViewModal.bind(this)}
              >
                &times;
              </button>
              <h4 className="modal-title">Create New View</h4>
            </Modal.Header>
            <Modal.Body>
              <label className="control-label"><strong>Saved View Name</strong></label>
              <br/>
              <input type="text" value={this.state.value} className="form-control" placeholder="View Name" onChange={this.handleChange.bind(this)} />
              <br />
              <button type="button" className="btn btn-sm btn-danger pull-right" data-dismiss="modal" onClick={this.closeCreateViewModal.bind(this)}>
                Cancel
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button type="button" className="btn btn-sm btn-success pull-right" onClick={this.createNewView.bind(this)}>Save</button>
            </Modal.Body>
          </Modal>

          {viewLayout === 'detail' && (
            <div className="table-layout detail">
              <div className="table-cell notes-list">
                {/* widget */}
                <JarvisWidget
                  colorbutton={false}
                  editbutton={false}
                  togglebutton={false}
                  deletebutton={false}
                  color="white"
                >
                  <header>
                    <h2>
                      <strong>Advocates</strong>
                    </h2>
                    <div className="widget-toolbar">
                      <Dropdown className="btn-group" id="widget-demo-dropdown">
                        <Dropdown.Toggle className="btn btn-xs dropdown-toggle">
                          Sort{' '}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu pull-right">
                          <MenuItem
                            className={
                              sort.indexOf('lastOutreachDate') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('lastOutreachDate')}
                          >
                            Last Outreach Date
                            {sort.indexOf('lastOutreachDate') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('lastOutreachDate') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('visitsLast12') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('visitsLast12')}
                          >
                            Visits (12 mos.)
                            {sort.indexOf('visitsLast12') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('visitsLast12') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('lastVisit') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('lastVisit')}
                          >
                            Last Visit
                            {sort.indexOf('lastVisit') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('lastVisit') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('nextVisitDue') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('nextVisitDue')}
                          >
                            Next Scheduled Visit
                            {sort.indexOf('nextVisitDue') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('nextVisitDue') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('DOB') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('DOB')}
                          >
                            Patient DOB
                            {sort.indexOf('DOB') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('DOB') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('nextFlowUpAt') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('nextFlowUpAt')}
                          >
                            Follow Up Date
                            {sort.indexOf('nextFlowUpAt') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('nextFlowUpAt') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('rxSpend') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('rxSpend')}
                          >
                            Rx Spend
                            {sort.indexOf('rxSpend') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('rxSpend') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </header>
                  <div className="clinic-activity-widget-wrapper">
                    <div className="widget-body clinic-activity-widget-body">
                      <div className="input-group add-on">
                        <input className="form-control" placeholder="Search" name="search-term" id="search-term" type="text" />
                        <div className="input-group-btn">
                          <button className="btn btn-default" onClick={() => this.setSearch($('#search-term').val())} type="submit"><i className="glyphicon glyphicon-search"></i></button>
                        </div>
                      </div>
                      <AdvocatesList
                        data={data}
                        isLoading={isLoading}
                        selected={this.state.selectedNote}
                        fetchData={this.preFetch}
                        selectNote={this.selectNote}
                        onSearchChange={this.setSearch}
                        ref="AdvocatesList"
                        page={this.state.page}
                        perPage={this.state.perPage}
                        search={this.state.search}
                      />
                    </div>
                    {/* end widget content */}
                  </div>
                  {/* end widget div */}
                </JarvisWidget>
                {/* end widget */}
              </div>
              <div className="table-cell chart-review">
                <JarvisWidget
                  colorbutton={false}
                  editbutton={false}
                  togglebutton={false}
                  deletebutton={false}
                  color="white"
                  fullscreenbutton={true}
                >
                  <header>
                    {this.state.selectedNote && (
                      <h2>
                        <strong>{this.state.selectedNote.patientId}</strong>{' '}
                        <i>Patient Id</i>
                      </h2>
                    )}
                    {this.state.selectedNote && (
                      <div className="widget-toolbar">
                        <a disabled={isExecutive}
                          className="btn btn-primary"
                          onClick={() => this.toggleNotes(false, true)}
                        >
                          <i className="fa fa-pencil" />
                          <span className="hidden-xs">
                            &nbsp;Add Outreach
                          </span>
                        </a>
                      </div>
                    )}
                    {this.state.selectedNote && (
                      <div className="widget-toolbar">
                        <a disabled={isExecutive}
                          className="btn btn-primary"
                          onClick={() => this.patientProfile(this.state.selectedNote.patientId)}
                        >
                          <span className="hidden-xs">
                            Patient Profile
                          </span>
                        </a>
                        
                      </div>
                    )}
                    {this.state.selectedNote && (
                      <div className="widget-toolbar">
                        <a
                          className={`btn btn-default ${
                            this.canPrevNote() && !isLoading ? '' : 'disabled'
                            }`}
                          onClick={this.prevNote}
                        >
                          <i className="glyphicon glyphicon-chevron-left" />
                        </a>
                        <a
                          className={`btn btn-default ${
                            this.canNextNote() && !isLoading ? '' : 'disabled'
                            }`}
                          onClick={this.nextNote}
                        >
                          <i className="glyphicon glyphicon-chevron-right" />
                        </a>
                      </div>
                    )}
                    {/*{this.state.selectedNote && (*/}
                    {/*  <div className="widget-toolbar">*/}
                    {/*    <CopyToClipboard*/}
                    {/*      text={this.getNoteLink(*/}
                    {/*        this.state.selectedNote.patientId,*/}
                    {/*      )}*/}
                    {/*    >*/}
                    {/*      <a*/}
                    {/*        className="btn btn-default"*/}
                    {/*        title="Copy Visit Note's Link"*/}
                    {/*      >*/}
                    {/*        <i className="glyphicon glyphicon-link" />*/}
                    {/*      </a>*/}
                    {/*    </CopyToClipboard>*/}
                    {/*  </div>*/}
                    {/*)}*/}
                  </header>
                  <div className="clinic-activity-widget-wrapper">
                    <AdvocateView
                      ref="AdvocateViewWrapper"
                      data={advocate[this.state.selectedNote && this.state.selectedNote.patientId]}
                      outreaches={outreach.data}
                      showNotes={this.state.showNotes}
                      editFlagsMode={this.state.editFlagsMode}
                      toggleNotes={this.toggleNotes}
                      addAction={this.addAction}
                      view={view}
                    />
                  </div>
                </JarvisWidget>
              </div>
            </div>
          )}
          {viewLayout === 'list' && (
            <div className="table-layout list">
              <div className="table-cell notes-list">
                <JarvisWidget
                  colorbutton={false}
                  editbutton={false}
                  togglebutton={false}
                  deletebutton={false}
                  color="white"
                  fullscreenbutton={true}
                >
                  <header>
                    <h2>
                      <strong>Advocates</strong>
                    </h2>
                    <div className="widget-toolbar">
                      <a disabled={isExecutive}
                        className="btn btn-primary"
                        onClick={() => this.toggleNotes(false, true)}
                      >
                        <i className="fa fa-pencil" />
                        <span className="hidden-xs">
                          &nbsp;Add Outreach
                        </span>
                      </a>
                    </div>
                    <div className="widget-toolbar">
                      <Dropdown className="btn-group" id="widget-demo-dropdown">
                        <Dropdown.Toggle className="btn btn-xs dropdown-toggle">
                          Sort{' '}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu pull-right">
                          <MenuItem
                            className={
                              sort.indexOf('lastOutreachDate') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('lastOutreachDate')}
                          >
                            Last Outreach Date
                            {sort.indexOf('lastOutreachDate') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('lastOutreachDate') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('visitsLast12') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('visitsLast12')}
                          >
                            Visits (12 mos.)
                            {sort.indexOf('visitsLast12') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('visitsLast12') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('lastVisit') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('lastVisit')}
                          >
                            Last Visit
                            {sort.indexOf('lastVisit') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('lastVisit') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('nextVisitDue') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('nextVisitDue')}
                          >
                            Next Scheduled Visit
                            {sort.indexOf('nextVisitDue') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('nextVisitDue') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('DOB') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('DOB')}
                          >
                            Patient DOB
                            {sort.indexOf('DOB') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('DOB') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('nextFlowUpAt') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('nextFlowUpAt')}
                          >
                            Follow Up Date
                            {sort.indexOf('nextFlowUpAt') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('nextFlowUpAt') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('rxSpend') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('rxSpend')}
                          >
                            Rx Spend
                            {sort.indexOf('rxSpend') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('rxSpend') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="widget-toolbar">
                      <Dropdown className="btn-group" id="widget-demo-dropdown">
                        <Dropdown.Toggle className="btn btn-xs dropdown-toggle">
                          Filter{' '}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu pull-right">
                          <MenuItem
                            className={
                              filter.indexOf('re-yes') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('re-yes')}
                          >
                            Risk Engaged Yes
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('re-no') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('re-no')}
                          >
                            Risk Engaged No
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('risk-low') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('risk-low')}
                          >
                            Risk Low
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('risk-medium') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('risk-medium')}
                          >
                            Risk Medium
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('risk-high') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('risk-high')}
                          >
                            Risk High
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('PreD') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('PreD')}
                          >
                            PreDiabetes
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('DIA') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('DIA')}
                          >
                            Diabetes
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('HTN') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('HTN')}
                          >
                            Hypertension
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('HLD') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('HLD')}
                          >
                            Hyperlipidemia
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('AS') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('AS')}
                          >
                            Asthma
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('OB') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('OB')}
                          >
                            Obesity
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('pg-yes') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('pg-yes')}
                          >
                            Performance Guarantee Yes
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('pg-no') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('pg-no')}
                          >
                            Performance Guarantee No
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('hcc-yes') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('hcc-yes')}
                          >
                            High-Cost Claimant Yes
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('hcc-no') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('hcc-no')}
                          >
                            High-Cost Claimant No
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('smoker-yes') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('smoker-yes')}
                          >
                            Smoker Yes
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('smoker-no') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('smoker-no')}
                          >
                            Smoker No
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('radius-outside') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('radius-outside')}
                          >
                            Radius Outside
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('radius-inside') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('radius-inside')}
                          >
                            Radius Inside
                          </MenuItem>
                          <MenuItem divider />
                          <MenuItem onClick={() => this.setFilter('')}>
                            <i className="fa fa-power-off" /> Clear
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </header>
                  <div className="clinic-activity-widget-wrapper">
                    <div className="widget-body clinic-activity-widget-body">
                      <div className="input-group add-on">
                        <input className="form-control" placeholder="Search" name="search-term" id="search-term" type="text" />
                        <div className="input-group-btn">
                          <button className="btn btn-default" onClick={() => this.setSearch($('#search-term').val())} type="submit"><i className="glyphicon glyphicon-search"></i></button>
                        </div>
                      </div>
                      <AdvocateTable
                        ref="AdvocateTable"
                        simpleView={false}
                        data={data}
                        isLoading={isLoading}
                        selected={this.state.selectedNote}
                        fetchData={this.preFetch}
                        selectNote={this.selectNote}
                        onSearchChange={this.setSearch}
                        view={view}
                        page={this.state.page}
                        perPage={this.state.perPage}
                        search={this.state.search}
                        showNotes={this.state.showNotes}
                        toggleNotes={this.toggleNotes}
                        addAction={this.addAction}
                        outreaches={outreach.data}
                        advocate={advocate[this.state.selectedNote && this.state.selectedNote.patientId]}
                    />
                  </div>
                  </div>
                </JarvisWidget>
              </div>
            </div>
          )}

        </WidgetGrid>
      </div>
    );
  }
}

const selectLocation = (state) => {
  if (state.currentUser.queryParams.practiceId && state.locations.list) {
    return state.locations.list.find(
      (el) => el.id === state.currentUser.queryParams.practiceId,
    );
  }
  return null;
};

export default connect(
  (state) => ({
    currentUser: state.currentUser,
    locations: state.location,
    currentLocation: selectLocation(state),
    advocate: state.advocates.advocate,
    queries: state.advocates.queries,
    outreach: state.outreach,
    isAdvocateLoading: state.advocates.isAdvocateLoading
  }),
  (dispatch) => ({
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    locationsTypeahead: (params) => dispatch(requestLocationsTypeahead(params)),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    employersTypeahead: (params) => dispatch(requestEmployersTypeahead(params)),
    filtersTypeahead: (params) => dispatch(requestFiltersTypeahead(params)),
    getAdvocate: (id, params) => dispatch(requestAdvocate(id, params)),
    getOutreaches: (params) => dispatch(requestOutreaches(params)),
    updateOutreach: (task, params) => dispatch(updateOutreach(task, params)),
    importData: (params, files) => dispatch(importOutreachData(params, files)),
    getAdvocateQuery: (params) => dispatch(requestAdvocateQuery(params)),
    saveAdvocateQuery: (query, params) => dispatch(saveAdvocateQuery(query, params)),
    updateAdvocateQuery: (queryId, params) => dispatch(updateAdvocateQuery(queryId, params)),
    deleteAdvocateQuery: (queryId, params) => dispatch(deleteAdvocateQuery(queryId, params))
  }),
)(AdvocateLayout);



// WEBPACK FOOTER //
// ./src/routes/management/components/AdvocateLayout.js